import React from 'react';
import { CloseOutlined } from '@ant-design/icons';

import { CloseIconWrapper } from './styled.tsx';

interface Props {
    onClick: () => void;
}

const CloseIcon: React.FC<Props> = ({ onClick }) => (
    <CloseIconWrapper onClick={onClick}>
        <CloseOutlined />
    </CloseIconWrapper>
);

export default CloseIcon;
